export const columns = [
  { label: '唯一标识', prop: 'afid', width: 150 },
  { label: 'AF_Dev key', prop: 'afDevKey', width: 150 },
  { label: 'FirebaseApi', prop: 'firebaseApiSecret', width: 150 },
  { label: '产品名称', prop: 'appName', width: 160 },
  { label: '发布市场', prop: 'publishMarketName', width: 140 },
  { label: '平台类型', prop: 'publishPlatformName', width: 140 },
  { label: '渠道号', prop: 'channelNum', width: 140 },
  { label: 'DBTID', prop: 'dbtId', width: 140 },
  { label: '投放渠道', prop: 'mediaSourceList', width: 200 },
  { label: '工作室', prop: 'productGroupName', width: 140 },
  { label: '小组', prop: 'squadName' },
  { label: '原始ID', prop: 'originId', width: 140 },
  { label: '投放名', prop: 'launchName', width: 140 },
  { label: '主体类别', prop: 'deliverySubType' },
  { label: '投放主体', prop: 'deliveryName' },
  { label: '变现形式', prop: 'realizationType' },
  { label: '域名组', prop: 'accountGroupCode' },
  { label: 'af账号ID', prop: 'afAccountName' },
  { label: '推广状态', prop: 'popuStatus' },
  { label: '备注', prop: 'mark', width: 140 },
  { label: '引力appid', prop: 'gravityAppId', width: 140 },
  { label: '引力appkey', prop: 'gravityAppKeyName', width: 140 },
  { label: '引力归因回调链接', prop: 'gravityCallBackLink', width: 200 },
  { label: '创建人', prop: 'creator', width: 140 },
  { label: '最后修改人', prop: 'modifier', width: 140 },
  { label: '引力归因时间', prop: 'gravityStartDate', width: 200 },
]
